import { LoadingOutlined } from '@ant-design/icons'
import { Flex, Row, Spin } from 'antd'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useRecoilState } from 'recoil'
import orderApi from '../../api/order.api'
import { userState } from '../../store/user'

const CancelReturnDashboard = () => {
  const navigate = useNavigate()
  const [user, setUser] = useRecoilState(userState)
  const [orderLoading, setOrderLoading] = useState(true)
  const [isLoading, setIsLoading] = useState(false)
  const [orderDeliveryStatus, setOrderDeliveryStatus] = useState({
    cancelRequest: 0,
    returnRequest: 0,
    returnDeliveryComplete: 0,
    returnCollectionFail: 0,
    returnDelay: 0,
    returnRefundDelay: 0,
  })

  const getOrderDeliveryStatus = async () => {
    try {
      const res = await orderApi.salesManageStatus(null, user.id)
      // console.log('getOrderDeliveryStatus res,:', res)
      if (res.data.code === 200) {
        setOrderDeliveryStatus({
          ...orderDeliveryStatus,
          cancelRequest: res.data.result.cancelRequestList.length ?? 0,
          returnRequest: res.data.result.returnRequestList?.length ?? 0,
          returnDeliveryComplete:
            res.data.result.returnDeliveryCompleteList.length ?? 0,
          returnCollectionFail:
            res.data.result.returnCollectionFailList.length ?? 0, //수거 실패
          returnDelay: res.data.result.returnDelayList.length ?? 0, // 반품 지연
          returnRefundDelay: res.data.result.returnRefundDelayList.length ?? 0, //환불 지연
        })
      }
    } catch (e) {
      console.log('getOrderDeliveryStatus e', e)
    } finally {
      setOrderLoading(false)
    }
  }

  useEffect(() => {
    setIsLoading(true)
    getOrderDeliveryStatus()
    // getUnansweredProductQuestion()
    const timer = setTimeout(() => {
      setIsLoading(false)
    }, 500)
    return () => {
      clearTimeout(timer)
    }
  }, [])

  const listTitle = (key) => {
    if (key === 'cancelRequest') {
      return '취소요청'
    } else if (key === 'returnRequest') {
      return '반품요청'
    } else if (key === 'returnDeliveryComplete') {
      return '반품배송완료'
    } else if (key === 'returnCollectionFail') {
      return '반품수거요청실패'
    } else if (key === 'returnDelay') {
      return '반품지연'
    } else if (key === 'returnRefundDelay') {
      return '환불지연'
    }
  }

  const handleNavigate = (key) => {
    if (key === 'cancelRequest') {
      navigate('/order/cancel')
    } else if (key === 'returnRequest') {
      navigate('/order/return?type=return_request')
    } else if (key === 'returnDeliveryComplete') {
      navigate('/order/return?type=return_delivery_complete')
    } else if (key === 'returnCollectionFail') {
      navigate('/order/return?type=return_collection_fail')
    } else if (key === 'returnDelay') {
      navigate('/order/return?type=return_delay')
    } else if (key === 'returnRefundDelay') {
      navigate('/order/return?type=return_refund_delay')
    }
  }

  return (
    <Flex
      vertical
      style={{ minWidth: '280px', height: '100%' }}
      className={`home-dashboard-component ${isLoading ? 'container-disable' : ''}`}
    >
      {orderLoading && (
        <Spin
          className={'home-dashboard-loading'}
          indicator={<LoadingOutlined spin />}
          size={'large'}
        />
      )}
      <Flex align={'center'} gap={4} className={'home-dashboard-title'}>
        <h2>취소/반품</h2>
      </Flex>
      <Flex
        vertical
        justify={'center'}
        gap={20}
        className={'inquiry-list-wrap '}
        style={{ paddingBottom: '44px' }}
      >
        {Object.keys(orderDeliveryStatus).map((key, idx) => (
          <Row
            key={`cancel-refund-list-${idx}`}
            className={'inquiry-list-div dash-cursor'}
            style={{ justifyContent: 'space-between', display: 'flex' }}
            onClick={() => handleNavigate(key)}
          >
            <p>{listTitle(key)}</p>
            <div className={'inquiry-list-count-div'}>
              <p>{orderDeliveryStatus[key]?.toLocaleString()} 건</p>
            </div>
          </Row>
        ))}
      </Flex>
    </Flex>
  )
}
export default CancelReturnDashboard
